// Review.raitingを☆で動的にする
const rating = document.querySelector('.js-review-rating');
const stars = document.querySelectorAll('.js-review-star');

stars.forEach((star, index) => {
  star.addEventListener('click', () => {
    rating.value = index + 1;

    stars.forEach(s => s.classList.remove('is-checked'));

    for (let i = 0; i <= index; i++) {
      stars[i].classList.add('is-checked');
    }
  });
});